module.exports = __webpack_public_path__ + "src/assets/img/lighting-right.07f316ef.svg";